import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M12 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7ZM6.5 6.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm5.5 10c-2.552 0-4.977.985-6.491 1.768-.671.348-1.125 1.055-1.228 1.92L4.126 21.5h15.748l-.155-1.312c-.103-.865-.556-1.572-1.228-1.92C16.977 17.485 14.552 16.5 12 16.5Zm-7.41-.008C6.221 15.648 8.982 14.5 12 14.5s5.779 1.148 7.41 1.992c1.359.703 2.128 2.055 2.295 3.46l.288 2.43A1 1 0 0 1 21 23.5H3a1 1 0 0 1-.993-1.118l.288-2.43c.167-1.405.936-2.757 2.295-3.46Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
